<p-confirmDialog key="topicmodify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Name:</label>
	<input [disabled]="Processing == true" class="form-control" type="text" [(ngModel)]="TopicCD" maxlength="50" />

	<label>Description:</label>
	<textarea [disabled]="Processing == true" class="form-control TextArea" [(ngModel)]="TopicDesc" maxlength="256" rows="7"></textarea>

	<label>School:</label>
	<label class="InfoText">{{ SchoolName }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" [disabled]="Processing == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" [disabled]="Processing == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessageErrorMessage }}</div>
</div>
